import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
// import MessengerCustomerChat from 'react-messenger-customer-chat';
import FingotiNav from '@fingoti/nav';
import { useFingotiAuth } from '@fingoti/auth-js/react';
import { FingotiButton } from '@fingoti/components';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { useProfileState } from '../context/ProfileContext';
import { ProfileData } from '../context/ProfileData';
import { apiService } from '../services/api.service';
import * as appConfig from '../services/config';

const useStyles = makeStyles(theme => ({

    root: {
        maxWidth: '100%',
        padding: theme.spacing(1),
        margin: 0,
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(100% - 114px);',
            marginLeft: 'auto',
            marginRight: 'auto',
            padding: theme.spacing(3),
        }
    },

    contextBanner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(1, 2),
        background: theme.palette.secondary.main,
        color: theme.palette.common.white,
        borderRadius: 0,
    },

}))

const Layout = ({ children }) => {

    const history = useHistory();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { orgContext, isHomeOrg, isActingAs, enterOrgContext, exitOrgContext } = useFingotiAuth();
    const { organisation } = useProfileState();
    const profileData = ProfileData();

    const handleExitOrgContext = async () => {
        try {
            // Revokes only the swapped (switch/act-as) family and restores the
            // primary session.
            await exitOrgContext();
            // Refetch the profile so the app drops back to the home org context.
            await profileData.getData();
            history.push('/organisation');
        } catch (error) {
            enqueueSnackbar(
                error?.description ?? error?.message ?? 'Unable to exit organisation',
                { variant: 'error' }
            );
        }
    }

    const handleSideNavClick = (link) => {
        history.push(link);
    }

    const handleBackClick = () => {
        history.goBack();
    }

    const handleSwitchOrganisation = async (oid) => {
        // Nesting isn't allowed — the SDK throws if we're already in a non-home
        // context. Steer the user to exit first rather than surfacing that error.
        if (!isHomeOrg) {
            enqueueSnackbar('Exit the current organisation before switching again', {
                variant: 'info',
            });
            return;
        }
        try {
            // The server resolves this to a membership switch or act-as based on
            // the user's membership of the target.
            await enterOrgContext(oid);
            await profileData.getData();
            history.push('/organisation');
        } catch (error) {
            enqueueSnackbar(
                error?.description ?? error?.message ?? 'Unable to switch organisation',
                { variant: 'error' }
            );
        }
    }

    const handleLogout = () => {
        history.push('/logout');
    }

    return (
        <React.Fragment>
            <FingotiNav
                onSideNavClick={handleSideNavClick}
                onBackClick={handleBackClick}
                currentApp="account"
                useProfileState={useProfileState}
                handleSwitchOrganisation={handleSwitchOrganisation}
                apiService={apiService}
                handleLogout={handleLogout}
                config={appConfig}
            />
            {!isHomeOrg && orgContext &&
                <Paper className={classes.contextBanner} elevation={0} square>
                    <Typography variant="body2">
                        {`${isActingAs ? 'You are acting as' : 'You are viewing'} ${organisation?.organisationName ?? orgContext.targetOid}`}
                    </Typography>
                    <FingotiButton light color="secondary" onClick={handleExitOrgContext}>
                        exit
                    </FingotiButton>
                </Paper>
            }
            <Container className={classes.root}>
                {children}
            </Container>
            {/* {isDesktop &&
                <MessengerCustomerChat
                    pageId="215950192435406"
                    htmlRef={window.location.pathname}
                />
            } */}
        </React.Fragment>
    );
}

export default Layout;
